<ion-card>
  <ion-card-content>
    <div class="service-data">
      <img class="service-icon" src="{{ service.image }}" alt="{{ service.name }}">
    </div>

    <div class="service-desc">
      <h6 class="service-title">{{ service.name }}</h6>
      <div innerHTML="{{ service.description }}">

      </div>

    </div>
  </ion-card-content>
</ion-card>
